// Single source of truth for the app version.
// Bump APP_VERSION on each meaningful change and record it in /app/memory/CHANGELOG.md.
// At live-production launch, set SHOW_FOOTER_VERSION = false (we keep tracking versions in the docs).
export const APP_VERSION = "0.12.3";
export const IS_BETA = true;
export const SHOW_FOOTER_VERSION = true;
